import { createReducer } from "typesafe-actions";
import { quoteOrderAsync, createOrderAsync, resetOrder, getHistoricalOrdersAsync, getPaymentIntentAsync } from "../actions/OrderActions";
import { Throwing } from "../../models/common";
import { Delivery, OrderResolverResolution, MissingProduct } from "../../api/models/QuotedData";
import { HistoricalOrder, PaymentCard } from "../../api/models/OrderData";

interface OrderState extends Throwing {
    createOrderBusy: boolean,
    quoteOrderBusy: boolean | null,
    quotedOrder: Delivery | null,
    quotedOrderResolution: OrderResolverResolution | null,
    currentOrderId: number | null,
    getHistoricalOrdersBusy: boolean,
    historicalOrders: HistoricalOrder[] | null
    noneFulfillsOrder: boolean | null,
    noneFulfillsDeadline: boolean | null,
    missingProducts: MissingProduct[] | null

    getPaymentIntentBusy: boolean,
    paymentIntentSecret: string | null,
    paymentCards: PaymentCard[] | null
}

const initialState: OrderState = {
    createOrderBusy: false,
    quoteOrderBusy: false,
    currentOrderId: null,
    quotedOrder: null,
    quotedOrderResolution: null,
    getHistoricalOrdersBusy: false,
    historicalOrders: null,
    noneFulfillsOrder: null,
    noneFulfillsDeadline: null,
    missingProducts: null,

    getPaymentIntentBusy: false,
    paymentIntentSecret: null,
    paymentCards: null
}

export const orderReducer = createReducer(initialState)

    //As we always create order and then quote it, set busy state for both
    .handleAction(createOrderAsync.request, (state) => { return { ...state, createOrderBusy: true, quoteOrderBusy: true } })
    .handleAction(createOrderAsync.success, (state, action) => {
        return { ...state, createOrderBusy: false, currentOrderId: action.payload }
    })
    .handleAction(createOrderAsync.failure, (state, action) => {
        return { ...state, createOrderBusy: false, error: action.payload }
    })


    .handleAction(quoteOrderAsync.request, (state) => { return { ...state, quoteOrderBusy: true, noneFulfillsDeadline: null, noneFulfillsOrder: null, missingProducts: null } })
    .handleAction(quoteOrderAsync.success, (state, action) => {

        switch (action.payload.resolution) {
            case 1:
                return { ...state, quoteOrderBusy: false, quotedOrder: Object.assign(action.payload.delivery, { currency: 'AU$' }), noneFulfillsDeadline: false, noneFulfillsOrder: false }
            case 2:
                return { ...state, quoteOrderBusy: false, quotedOrder: null, noneFulfillsDeadline: null, noneFulfillsOrder: true }
            case 3:
                return { ...state, quoteOrderBusy: false, quotedOrder: null, noneFulfillsDeadline: true, noneFulfillsOrder: false }
            case 4:
                return { ...state, quoteOrderBusy: false, quotedOrder: Object.assign(action.payload.delivery, { currency: 'AU$' }), noneFulfillsDeadline: false, noneFulfillsOrder: false, missingProducts: action.payload.missingProducts }

            default:{
                console.log("Unsupported order resolution code.")
                return { ...state, quoteOrderBusy: false, quotedOrder: null, noneFulfillsDeadline: null, noneFulfillsOrder: false, missingProducts: null }
            }
        }
    })
    .handleAction(quoteOrderAsync.failure, (state, action) => {
        return { ...state, quoteOrderBusy: false, error: action.payload }
    })


    .handleAction(getHistoricalOrdersAsync.request, (state) => { return { ...state, getHistoricalOrdersBusy: true } })
    .handleAction(getHistoricalOrdersAsync.success, (state, action) => {
        return { ...state, getHistoricalOrdersBusy: false, historicalOrders: action.payload }
    })
    .handleAction(getHistoricalOrdersAsync.failure, (state, action) => {
        return { ...state, getHistoricalOrdersBusy: false, error: action.payload }
    })


    .handleAction(getPaymentIntentAsync.request, (state) => { return { ...state, getPaymentIntentBusy: true } })
    .handleAction(getPaymentIntentAsync.success, (state, action) => {
        return { ...state, 
            getPaymentIntentBusy: false, 
            paymentIntentSecret: action.payload.clientSecret,
            paymentCards: action.payload.cards
         }
    })
    .handleAction(getPaymentIntentAsync.failure, (state, action) => {
        return { ...state, getPaymentIntentBusy: false, error: action.payload }
    })



    .handleAction(resetOrder, (state) => {
        return { ...state, quotedOrder: null, currentOrderId: null }
    })

export default orderReducer;